import styled from 'styled-components';

export const AuditModalContent = styled.div`
  font-family: inherit;
  color: #1f2433;
  padding: 20px 24px 24px;
  position: relative;

  .audit-close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    border: none;
    background: transparent;
    cursor: pointer;
    color: #8a90a2;
    font-size: 16px;
    padding: 6px;
    line-height: 1;
    border-radius: 6px;
    transition: background 0.15s ease, color 0.15s ease;
  }
  .audit-close-btn:hover {
    background: #f2f3f7;
    color: #1f2433;
  }

  .audit-header {
    padding: 4px 0 20px;
  }

  .audit-eyebrow {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #6c5ce7;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    margin-bottom: 6px;
  }

  .audit-title {
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 4px;
  }

  .audit-subtitle {
    font-size: 13px;
    color: #8a90a2;
    margin: 0;
  }

  .audit-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .audit-table thead th {
    text-align: left;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
    color: #9aa0b1;
    font-weight: 600;
    padding: 10px 12px;
    border-bottom: 1px solid #eef0f4;
  }

  .audit-table tbody td {
    padding: 14px 12px;
    border-bottom: 1px solid #f2f3f7;
    vertical-align: top;
  }

  .when-primary {
    font-weight: 600;
  }
  .when-secondary {
    color: #9aa0b1;
    font-size: 12px;
    margin-top: 2px;
  }

  .transition {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
  }
  .pill.open {
    background: #e7f7ee;
    color: #1f9d57;
  }
  .pill.booked {
    background: #fdecec;
    color: #d6453d;
  }
  .pill.yes {
    background: #fff4e5;
    color: #b9740a;
  }
  .pill.no {
    background: #eef0f4;
    color: #5b6172;
  }
  .pill .dot {
    font-size: 8px;
    line-height: 1;
  }
  .arrow {
    color: #c2c6d2;
  }

  .action-tag {
    display: inline-block;
    padding: 3px 10px;
    border: 1px solid #e3e5ee;
    border-radius: 6px;
    font-weight: 600;
    color: #3d4252;
  }

  .actor {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
  }
  .actor-name {
    font-weight: 600;
  }
  .actor-email {
    color: #9aa0b1;
    font-size: 12px;
  }

  .event-link {
    color: #6c5ce7;
    font-weight: 600;
    cursor: pointer;
  }
  .no-event {
    color: #9aa0b1;
  }

  .opens-delta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
  }
  .opens-old {
    color: #d6453d;
    background: #fdecec;
    padding: 1px 6px;
    border-radius: 4px;
  }
  .opens-new {
    color: #1f9d57;
    background: #e7f7ee;
    padding: 1px 6px;
    border-radius: 4px;
  }
  .muted {
    color: #c2c6d2;
  }

  .audit-empty {
    padding: 40px 0;
    text-align: center;
    color: #9aa0b1;
  }
`;
